import { Table, TableBody, TableContainer } from '@mui/material'
import CustomersResellersTableHeads from './CustomersResellersTableHead'
import CustomersResellersRowRender from './CustomersResellersRowRender'

const CustomersResellersTable = ({ customersResellers }: any) => (
  <TableContainer sx={{ overflowX: !customersResellers?.length ? 'hidden' : null }}>
    <Table
      sx={{ '& .MuiTableCell-root': { paddingLeft: 0, paddingRight: 0 } }}
      aria-labelledby="tableTitle"
      size="medium"
    >
      <CustomersResellersTableHeads />
      <TableBody>
        <CustomersResellersRowRender rows={customersResellers} />
      </TableBody>
    </Table>
  </TableContainer>
)

export default CustomersResellersTable
